module.exports = __webpack_public_path__ + "static/img/national.58f55c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/national.png
// module id = vrSw
// module chunks = 18